// extracted by mini-css-extract-plugin
export var cancelButton = "_qf-5";
export var content = "_qf-3";
export var createButton = "_qf-6";
export var drawerContainer = "_qf-0";
export var footer = "_qf-2";
export var header = "_qf-1";
export var orderFormColumn = "_qf-4";